import clsx from 'clsx';
import React from 'react';

import { Button } from '@/components/button/button';
import { Heading } from '@/components/typography/heading';
import { Text } from '@/components/typography/text';

import styles from './not-found.module.scss';

export default function NotFound() {
  return (
    <div className={ clsx( 'page', 'center_xy', styles.notFound ) }>
      <p className={ styles.code }>404</p>
      <Heading className={ styles.heading }>Uh oh...</Heading>
      <Text className={ styles.message }>
        You accidentally stumbled here instead of trying to be somewhere you shouldn&apos;t be right?
      </Text>
      <Button asLink href='/'>Return Home</Button>
    </div>
  );
}
